import React from 'react';
import { Container } from '@material-ui/core';
import { dateToLocal } from '../shared/Functions';
import { useParams } from 'react-router';
import { ImagesVService } from '../../services/V2/aurascope';
import { authProvider } from '../../services/Security';
import { CustomTable } from '../shared/CustomTable';

export const MeterImagesMini = (props) => {
    const { routeId, meterId } = useParams<{ routeId: string | undefined, meterId: string | undefined }>();
    const [loading, setLoading] = React.useState<boolean>(true);

    window.addEventListener('message', event => {
        // IMPORTANT: check the origin of the data!
        if (!event.data) return;
        var data = JSON.parse(event?.data);
        authProvider.setToken(data?.token)
        // if (event.origin === 'https://your-first-site.example') {
        //     // The data was sent from your site.
        //     // Data sent with postMessage is stored in event.data:
        // } else {
        //     // The data was NOT sent from your site!
        //     // Be careful! Do not use it. This else branch is
        //     // here just for clarity, you usually shouldn't need it.
        //     return;
        // }
    });

    return (
        <React.Fragment>
            <Container maxWidth="xl">
                <CustomTable
                    title="Meter Images"
                    columns={[
                        { title: 'Id', field: 'id', editable: 'never' },
                        { title: 'Image', field: 'preSignedUrl', editable: 'never', render: rowData => <img alt="error" style={{ maxHeight: "70px" }} src={rowData.preSignedUrl} /> },
                        { title: 'Created At', field: 'createdAt', editable: 'never', render: rowData => dateToLocal(rowData.createdAt).toLocaleString(), defaultSort: "desc" },
                        { title: 'Created By', field: 'createdBy', editable: 'never' }
                    ]}
                    dataEndpoint={query => {
                        return new Promise((resolve, reject) => {
                            var filters: any[] = [];
                            if (routeId) filters.push({
                                property: "MeterRouteId",
                                value: routeId
                            });
                            if (meterId) filters.push({
                                property: "MeterId",
                                value: meterId
                            });
                            ImagesVService.imagesVGetAll({
                                pageNumber: query.page + 1,
                                numberPerPage: query.pageSize,
                                orderBy: query?.orderBy?.field?.toString() ?? "Id",
                                orderByDesc: query.orderDirection === "desc",
                                filters: filters,
                                searchQuery: query.search
                            }).then((x: any) => {
                                resolve({
                                    data: x.items ?? [],
                                    page: query.page,
                                    totalCount: x.numberOfItems ?? 0
                                })
                            }).catch(x => {
                                reject(x)
                            })
                        })
                    }}
                    actions={[
                    ]}
                    refresh={loading} setRefresh={setLoading} pageSize={15} enablePaging={true}
                    districtId={null} addedQuery={null} hiddenColumns={[]} setHiddenColumns={() => { }} hiddenColumnsDisabled={true}
                    tableHeight={"400px"} enableSearch={false} searchPlaceholder={null} dataSet={null}
                />
            </Container>
        </React.Fragment>
    );
}